import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";
import "@/App.css";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      setError("Missing sign-in session. Please try again.");
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((res) => navigate("/owner/dashboard", { state: { user: res.data.user }, replace: true }))
      .catch((err) => setError(err.response?.data?.detail || "Sign-in failed. Please try again."));
  }, [location, navigate]);

  return (
    <div className="site-shell auth-page" data-testid="auth-callback">
      <div className="noise" aria-hidden="true" />
      <div className="auth-card">
        {error ? (
          <>
            <h1>Access denied</h1>
            <p className="auth-error" data-testid="auth-callback-error">{error}</p>
            <Link className="auth-back" data-testid="auth-callback-back-link" to="/owner">&larr; Back to owner login</Link>
          </>
        ) : (
          <>
            <Loader2 className="spin" size={30} style={{ color: "var(--cyan)", margin: "0 auto" }} />
            <p style={{ marginTop: 18, color: "var(--muted)" }} data-testid="auth-callback-status">Signing you in...</p>
          </>
        )}
      </div>
    </div>
  );
}
